import { matchPath } from "react-router";
import { OrganizationDto } from "../../common/service/server/dto/OrganizationDto";
import { Routes } from "./routes";

// StayCompliantPageRouter already redirects /get-compliant/* to the user's home.
// Normalize only known completed-page URLs when an org is moved back into FTUE.
export function getPhaseRedirect(
  pathname: string,
  organization: Pick<OrganizationDto, "id" | "phase">,
): string | undefined {
  if (organization.phase !== "GET_COMPLIANT") {
    return undefined;
  }

  if (matchPath(pathname, { path: Routes.dashboard.root, exact: true })) {
    return Routes.getCompliant.dashboard;
  }

  const domainSettings = matchPath<{ organizationId: string }>(pathname, {
    path: Routes.organization.settings.domain,
    exact: true,
  });
  if (domainSettings?.params.organizationId === organization.id) {
    return Routes.getCompliant.privacyCenter.domainSetup;
  }

  // Do not turn unknown URLs or another organization's settings into this org's page.
  return undefined;
}
